import React from "react";
import { Row, Col } from "antd";

function MotivateUs() {
    return (
        <div className="motivateUs">
            <div className="custom-container">
                <div className="svg--bg">
                    <svg
                        width="914"
                        height="914"
                        viewBox="0 0 914 914"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="457" cy="457" r="457" fill="#F5F5F5" />
                    </svg>
                </div>
                <div className="title">
                    <h1>What Motivates Us</h1>
                    <Row>
                        <Col xs={{ span: 24 }} md={{ span: 12 }}>
                            <p>
                                Motivation is a very important daily basis. But
                                those mechanisms that are in use are far from
                                reality and too unfair. Like taking part in
                                challenges where each rider has a different
                                level and riding on a different terrain. So you
                                are competing with some ghost competitor with
                                minimum chances to win some mystic badge. Not so
                                motivating, isn't it?
                            </p>
                        </Col>
                    </Row>
                </div>
                <div className="our--numbers">
                    <Row>
                        <Col xs={{ span: 24 }} md={{ span: 6 }}>
                            <div className="">
                                <h2>Our</h2>
                                <h2>Numbers</h2>
                            </div>
                        </Col>
                        <Col xs={{ span: 24 }} md={{ span: 18 }}>
                            <Row>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 12 }}
                                    md={{ span: 6 }}
                                >
                                    <div className="number-wrap">
                                        <h2 className="number-wrap__client">
                                            31
                                        </h2>
                                        <p>Clients</p>
                                    </div>
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 12 }}
                                    md={{ span: 6 }}
                                >
                                    <div className="number-wrap">
                                        <h2 className="number-wrap__years">
                                            1
                                        </h2>
                                        <p>Years</p>
                                    </div>
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 12 }}
                                    md={{ span: 6 }}
                                >
                                    <div className="number-wrap">
                                        <h2 className="number-wrap__team">
                                            10
                                        </h2>
                                        <p>Team</p>
                                    </div>
                                </Col>
                                <Col
                                    xs={{ span: 24 }}
                                    sm={{ span: 12 }}
                                    md={{ span: 6 }}
                                >
                                    <div className="number-wrap">
                                        <h2>41</h2>
                                        <p>Countries</p>
                                    </div>
                                </Col>
                            </Row>
                            <div className="pride">
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                        <h2>OUR PRIDE</h2>
                                        <p>
                                            But wait, training everyday is
                                            already a challenge and in the end,
                                            our self is the only competitor to
                                            overcome while pushing yourself to
                                            ride is already a win. There are a
                                            lot of real achievements reached
                                            every ride:
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default MotivateUs;
